import { UAParser } from 'ua-parser-js';

export const isIos = () => {
  const parser = new UAParser();
  const device = parser.getDevice();
  return device.model === 'iPhone';
};
